module.exports = __webpack_public_path__ + "static/media/speak_it_start_img.7e8d3b88.jpg";